var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 525.379,
    height: 525.879,
    viewBox: "0 0 525.379 525.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_193",
    x: 4.638,
    y: 17.184,
    width: 486.102,
    height: 477.511,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#006fff",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_194",
    x: 102.483,
    y: 95.055,
    width: 388.412,
    height: 401.769,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#006fff",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_192",
    x: 0,
    y: 0,
    width: 525.379,
    height: 525.879,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#006fff",
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(-162.5 -149.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 162.5, 149.57)",
    filter: "url(#Path_193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193-2",
    "data-name": "Path 193",
    d: "M238.8,22.649c88.637,0,153.469,42.7,153.469,137.892S337.623,283.879,245.95,340.312,144.829,380.148,83.543,363.805,8.724,345.675.808,274.941,45.751,107.2,45.751,51.249C45.751-43.946,150.163,22.649,238.8,22.649Z",
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 9.14, 118.71)",
    fill: "#aae1fa",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 162.5, 149.57)",
    filter: "url(#Path_194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194-2",
    "data-name": "Path 194",
    d: "M238.8,22.649c88.637,0,153.469,42.7,153.469,137.892S337.623,283.879,245.95,340.312,144.829,380.148,83.543,363.805,8.724,345.675.808,274.941,45.751,107.2,45.751,51.249C45.751-43.946,150.163,22.649,238.8,22.649Z",
    transform: "translate(486.4 95.05) rotate(90)",
    fill: "#aae1fa",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 162.5, 149.57)",
    filter: "url(#Path_192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192-2",
    "data-name": "Path 192",
    d: "M225.985,21.434c83.88,0,145.233,40.406,145.233,130.493S319.5,268.645,232.751,322.05s-95.695,37.7-153.691,22.232-70.8-17.157-78.3-84.1S43.3,101.451,43.3,48.5C43.3-41.588,142.1,21.434,225.985,21.434Z",
    transform: "translate(4.5 262.49) rotate(-45)",
    fill: "#e4e4e4",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(305.49 265.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(210.238 26.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M25.609,27.29l-.881.96a1.409,1.409,0,0,0,0,1.92,1.259,1.259,0,0,0,.881.4,1.242,1.242,0,0,0,.881-.4,1.409,1.409,0,0,0,0-1.92Z",
    transform: "translate(-2.909 -3.261)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M25.165,23.309,24.117,22.2l-1.057,1.109a1.638,1.638,0,0,0,0,2.228,1.435,1.435,0,0,0,2.1,0,1.62,1.62,0,0,0,0-2.228Z",
    transform: "translate(-2.703 -2.652)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M20.78,20.584V13.865a2.025,2.025,0,0,0-2.025-2.025H3.311a.881.881,0,1,0,0,1.761H18.781a.264.264,0,0,1,.264.264v6.718a.881.881,0,0,0,1.761,0Z",
    transform: "translate(-0.29 -1.415)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M20.155,5.627H12.741V4.4a4.6,4.6,0,0,1,1.039.079l1.356.15h.1a2.316,2.316,0,0,0,0-4.632L13.349.22a12.019,12.019,0,0,1-2.976,0L8.585,0H8.479a2.316,2.316,0,0,0,0,4.623l1.453-.15c.352,0,.7-.062,1.048-.079V5.627H.881a.881.881,0,1,0,0,1.761H20.155a2.888,2.888,0,0,1,2.879,2.879v8.9a.881.881,0,1,0,1.761,0v-8.9a4.649,4.649,0,0,0-4.64-4.64ZM9.747,2.721l-1.3.141a.546.546,0,0,1-.52-.546.555.555,0,0,1,.52-.555l1.717.211a14.626,14.626,0,0,0,3.4,0l1.761-.211a.564.564,0,0,1,.511.555.546.546,0,0,1-.52.546l-1.3-.141a20.922,20.922,0,0,0-2.148-.079h0A18.839,18.839,0,0,0,9.747,2.721Z",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2",
    transform: "translate(202.73 247.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M30.3,6.806l.44-1.189a.546.546,0,0,0-.652-.722L20.35,8.471H18.272a2.3,2.3,0,0,0-2.325,1.981,2.2,2.2,0,0,0,2.2,2.43h.616v1.9a.792.792,0,1,0,1.585,0v-1.9l.652.185a9.518,9.518,0,0,1-1.876,4.288A9.686,9.686,0,1,1,11.448,1.761a.881.881,0,1,0,0-1.761,11.447,11.447,0,1,0,9.078,18.429,11.271,11.271,0,0,0,2.175-4.9l7.432,2.043a.555.555,0,0,0,.6-.722C29.815,12.2,29.314,9.43,30.3,6.806Z",
    transform: "translate(-0.008 0)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M36.341,8.931a.881.881,0,0,0-1.514-.881,5.785,5.785,0,0,0,0,5.468.881.881,0,0,0,.784.475.977.977,0,0,0,.405-.1.881.881,0,0,0,.37-1.189A4.006,4.006,0,0,1,36.341,8.931Z",
    transform: "translate(-4.086 -0.919)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M40.32,13.991a7.194,7.194,0,0,1,0-6.78.881.881,0,0,0-1.514-.881,9.034,9.034,0,0,0,0,8.515.87.87,0,1,0,1.514-.854Z",
    transform: "translate(-4.516 -0.713)",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-3",
    "data-name": "Layer 2",
    transform: "translate(5.337 247.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-3",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M15.3,13.214l3.663-3.857a5.688,5.688,0,0,0,0-7.713,4.993,4.993,0,0,0-7.317,0,5.653,5.653,0,0,0,0,7.713Z",
    transform: "translate(-1.218 -0.048)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M27.35,21.26a8.4,8.4,0,0,0-2.342.335c-1.515.326-3.584.784-4.949.405-2-.546-3.381.141-4.843.881l-.881.44a.564.564,0,0,1-.475,0l-2.316-1.065a8.541,8.541,0,0,0-5.01-.528,12.407,12.407,0,0,1-5.283-.387H1.146a.873.873,0,0,0-1.136.845,14.088,14.088,0,0,0,28.124,0A.881.881,0,0,0,27.35,21.26ZM14.09,34.441A12.327,12.327,0,0,1,1.815,23.294a14.185,14.185,0,0,0,4.922.167,6.912,6.912,0,0,1,4.033.379l2.316,1.074a2.369,2.369,0,0,0,1.955,0l.96-.467c1.347-.678,2.237-1.118,3.593-.748,1.761.493,4.094,0,5.785-.387l.942-.194A12.327,12.327,0,0,1,14.09,34.441Z",
    transform: "translate(-0.01 -2.582)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M9.083,26.111A.881.881,0,0,0,8.2,25.23H5.561a.881.881,0,1,0,0,1.761H8.2A.881.881,0,0,0,9.083,26.111Z",
    transform: "translate(-0.568 -3.057)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M12.881,28.421h2.642a.881.881,0,0,0,0-1.761H12.881a.881.881,0,0,0,0,1.761Z",
    transform: "translate(-1.442 -3.228)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M22.262,28.761a.881.881,0,0,0,0-1.761H19.621a.881.881,0,0,0,0,1.761Z",
    transform: "translate(-2.248 -3.268)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M27.622,24.9H24.981a.881.881,0,0,0,0,1.761h2.642a.881.881,0,1,0,0-1.761Z",
    transform: "translate(-2.888 -3.017)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M10.682,29.53H8.041a.881.881,0,1,0,0,1.761h2.642a.881.881,0,0,0,0-1.761Z",
    transform: "translate(-0.864 -3.57)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M15.522,33H12.881a.881.881,0,0,0,0,1.761h2.642a.881.881,0,0,0,0-1.761Z",
    transform: "translate(-1.442 -3.985)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M17.46,29.81h-2.58a.881.881,0,0,0,0,1.761h2.642a.881.881,0,0,0,0-1.761Z",
    transform: "translate(-1.681 -3.604)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M23.262,30.25H20.621a.881.881,0,1,0,0,1.761h2.642a.881.881,0,0,0,0-1.761Z",
    transform: "translate(-2.367 -3.657)",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-4",
    "data-name": "Layer 2",
    transform: "translate(105.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-4",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M23.144,25.28l-2.113,2.237a3.276,3.276,0,0,0,0,4.464,2.888,2.888,0,0,0,4.235,0,3.276,3.276,0,0,0,0-4.464Z",
    transform: "translate(-2.408 -3.02)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M4.151,8.691H13.37a.881.881,0,1,0,0-1.761H4.151a.881.881,0,1,0,0,1.761Z",
    transform: "translate(-0.391 -0.828)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M18.186,21.061a.881.881,0,0,0-.881-.881H4.151a.881.881,0,1,0,0,1.761H17.306A.881.881,0,0,0,18.186,21.061Z",
    transform: "translate(-0.391 -2.411)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M20.8,8.691a.881.881,0,1,0,0-1.761H18.161a.881.881,0,1,0,0,1.761Z",
    transform: "translate(-2.065 -0.828)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M4.151,17.151H6.792a.881.881,0,1,0,0-1.761H4.151a.881.881,0,0,0,0,1.761Z",
    transform: "translate(-0.391 -1.839)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M9.211,15.39a.881.881,0,0,0,0,1.761h2.642a.881.881,0,0,0,0-1.761Z",
    transform: "translate(-0.995 -1.839)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M4.151,26.49a.881.881,0,0,0,0,1.761H6.792a.881.881,0,1,0,0-1.761Z",
    transform: "translate(-0.391 -3.165)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M16.969,28H15.261a.881.881,0,0,0-.634,1.488.881.881,0,0,0,.634,1.488h1.708a.881.881,0,0,0,.6-1.462.881.881,0,0,0-.6-1.514Z",
    transform: "translate(-1.719 -3.345)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M13.38,16.271a.881.881,0,0,0,.881.881h6a.881.881,0,0,0,0-1.761h-6A.881.881,0,0,0,13.38,16.271Z",
    transform: "translate(-1.599 -1.839)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M4.151,12.591H13.37a.881.881,0,1,0,0-1.761H4.151a.881.881,0,1,0,0,1.761Z",
    transform: "translate(-0.391 -1.294)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M25.72,4.966a.881.881,0,0,0-.74-.176A2.43,2.43,0,0,1,22.762,4.1a3.047,3.047,0,0,1-.81-2.756l.062-.3A.877.877,0,0,0,21.133,0H.881A.881.881,0,0,0,0,.88v32.3a.881.881,0,0,0,.881.881H19.688a.881.881,0,0,0,0-1.761H1.761V1.761H20.138A4.737,4.737,0,0,0,21.52,5.354,4.253,4.253,0,0,0,24.276,6.6V31.056a.881.881,0,1,0,1.761,0V5.653A.881.881,0,0,0,25.72,4.966Z",
    transform: "translate(0 0)",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-5",
    "data-name": "Layer 2",
    transform: "translate(227.73 109.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-5",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M22.9,6.12,21.3,7.775a2.492,2.492,0,0,0,0,3.381,2.175,2.175,0,0,0,3.205,0,2.474,2.474,0,0,0-.026-3.381Z",
    transform: "translate(-2.466 -0.731)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M33.257,1.981V1.153a.881.881,0,1,0-1.761,0V1.92H29.938V1.153a.881.881,0,0,0-1.761,0V1.92h-4.35L23.114.96a.881.881,0,0,0-.7-.352H20.648a.881.881,0,0,0-.7.352l-.713.96H12.715a.859.859,0,0,0-.9-.836l-5.6.15L5.723.423A.881.881,0,0,0,4.966,0H3.619a.881.881,0,0,0-.608.247L1.638,1.567a.881.881,0,0,0-.273.634v.343a.881.881,0,0,0-.881-.079.881.881,0,0,0-.484.8V5.389a.881.881,0,0,0,.308.669l.933.8.123.07v5.723a4.006,4.006,0,0,0,4,4A.881.881,0,0,0,5.97,16.4a2.862,2.862,0,0,0,2.642,1.761,2.2,2.2,0,0,0,.819-.132,1.558,1.558,0,0,0,.15-.106,2.835,2.835,0,0,0,1.127.238,2.879,2.879,0,0,0,2.871-2.871,2.554,2.554,0,0,0-.1-.7H24.928a3.082,3.082,0,0,0-.1.7,2.871,2.871,0,0,0,3.857,2.694.819.819,0,0,0,.335-.176,2.782,2.782,0,0,0,1.338.352,2.826,2.826,0,0,0,2.747-3.654A5.177,5.177,0,0,0,37.325,9.43V6.6a4.667,4.667,0,0,0-4.068-4.614ZM31.5,8.206H29.938V7.819h1.585ZM29.911,9.968H31.5v.379H29.938ZM31.5,6.058H29.938V5.679h1.585Zm-1.559,6.049h1.585v.59a2.791,2.791,0,0,0-1.153-.247,3.425,3.425,0,0,0-.431,0Zm1.585-8.427v.238H29.938V3.681Zm-3.346,8.805a2.642,2.642,0,0,0-.467,0,2.835,2.835,0,0,0-1.523.449,1.251,1.251,0,0,0-.176,0H12.688a.722.722,0,0,0-.238.053.881.881,0,0,0,.273-.634V3.681H28.177ZM3.971,1.761h.5l.5.828a.881.881,0,0,0,.775.423L9.633,2.9V5.926L3.6,6.41a.881.881,0,0,0-.475.211V2.571ZM5.785,15.013a.881.881,0,0,0-.423-.123,2.237,2.237,0,0,1-2.237-2.237V7.969a.881.881,0,0,0,.546.2h.07l6.824-.555a.81.81,0,0,0,.379-.132v4.843a.7.7,0,0,0,.044.194H10.7a2.7,2.7,0,0,0-1.136.238,1.347,1.347,0,0,0-.141-.1,2.245,2.245,0,0,0-.819-.141,2.871,2.871,0,0,0-2.818,2.492Zm1.761.308a1.092,1.092,0,0,1,.493-.881,2.694,2.694,0,0,0-.158.881,2.747,2.747,0,0,0,.158.881,1.083,1.083,0,0,1-.528-.881Zm3.205,1.109a1.109,1.109,0,1,1,1.109-1.109A1.109,1.109,0,0,1,10.751,16.431ZM26.6,15.321a1.1,1.1,0,0,1,1.109-1.109h0a2.906,2.906,0,0,0,0,2.219h0a1.109,1.109,0,0,1-1.136-1.109Zm3.769,1.109a1.143,1.143,0,1,0-.026,0Zm5.2-6.974a3.4,3.4,0,0,1-2.289,3.205V3.751A2.906,2.906,0,0,1,35.573,6.6Z",
    transform: "translate(0 0)",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-6",
    "data-name": "Layer 2",
    transform: "translate(55.285 174.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-6",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M25.622,29.559,22.188,25.94l-3.443,3.619a5.283,5.283,0,0,0,0,7.238,4.676,4.676,0,0,0,6.877,0A5.283,5.283,0,0,0,25.622,29.559Zm-1.761,4.279H23.1V34.6a.881.881,0,0,1-1.761,0v-.766h-.775a.881.881,0,1,1,0-1.761h.766v-.8a.881.881,0,0,1,1.761,0v.766h.766a.881.881,0,0,1,0,1.761Z",
    transform: "translate(-2.048 -3.099)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M12.325,34.059H2.41a.881.881,0,0,1-.881-.634C1.274,32.544-4.634,11.411,8.424.211A.881.881,0,0,1,9.031,0H28.87a.881.881,0,0,1,.687,1.435c-.079.088-7.344,9.193-8.259,20a.884.884,0,1,1-1.761-.15c.757-8.884,5.433-16.466,7.581-19.521H9.357c-10.734,9.5-7.132,27-6.261,30.537h9.228a.881.881,0,1,1,0,1.761Z",
    transform: "translate(0.023 0.001)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M20.614,5.131H11.281a.881.881,0,1,1,0-1.761h9.334a.881.881,0,1,1,0,1.761Z",
    transform: "translate(-1.222 -0.402)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M17.29,8.761H7.931A.881.881,0,0,1,7.931,7h9.36a.881.881,0,0,1,0,1.761Z",
    transform: "translate(-0.822 -0.836)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M24.086,8.761H20.881a.881.881,0,1,1,0-1.761H24.1a.881.881,0,0,1,0,1.761Z",
    transform: "translate(-2.369 -0.836)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M13.35,26.7H3.991a.881.881,0,1,1,0-1.761h9.36a.881.881,0,1,1,0,1.761Z",
    transform: "translate(-0.351 -2.979)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M20.138,26.7H16.881a.881.881,0,1,1,0-1.761h3.258a.881.881,0,1,1,0,1.761Z",
    transform: "translate(-1.891 -2.979)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M7.773,16.761H4.551a.881.881,0,1,1,0-1.761H7.773a.881.881,0,1,1,0,1.761Z",
    transform: "translate(-0.418 -1.791)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M14.643,16.761H11.421a.881.881,0,1,1,0-1.761h3.223a.881.881,0,1,1,0,1.761Z",
    transform: "translate(-1.239 -1.791)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M21.3,16.761H18.081a.881.881,0,1,1,0-1.761H21.3a.881.881,0,1,1,0,1.761Z",
    transform: "translate(-2.035 -1.791)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M15.33,12.981H5.971a.881.881,0,1,1,0-1.761h9.36a.881.881,0,1,1,0,1.761Z",
    transform: "translate(-0.588 -1.34)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M13.24,21.7H3.881a.881.881,0,1,1,0-1.761h9.36a.881.881,0,1,1,0,1.761Z",
    transform: "translate(-0.338 -2.382)",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-7",
    "data-name": "Layer 2",
    transform: "translate(-41 107.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-7",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M17.144,0A17.144,17.144,0,1,0,34.288,17.144,17.144,17.144,0,0,0,17.144,0Zm0,32.527A15.383,15.383,0,1,1,32.527,17.144,15.383,15.383,0,0,1,17.144,32.527Z",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M21.593,19.137a2.457,2.457,0,1,0-2.457,2.457,2.457,2.457,0,0,0,2.457-2.457Zm-3.152,0a.7.7,0,1,1,.7.7.7.7,0,0,1-.7-.7Z",
    transform: "translate(-1.993 -1.993)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 2.483,
    height: 3.689,
    rx: 0.25,
    transform: "translate(11.324 9.078)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 2.483,
    height: 3.689,
    rx: 0.25,
    transform: "translate(14.141 9.078)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 2.483,
    height: 3.689,
    rx: 0.25,
    transform: "translate(16.959 9.078)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 2.483,
    height: 3.689,
    rx: 0.25,
    transform: "translate(19.777 9.078)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M19.351,6.987a.881.881,0,0,0,.881-.881V4.091a.881.881,0,0,0-1.761,0V6.107A.881.881,0,0,0,19.351,6.987Z",
    transform: "translate(-2.207 -0.384)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M15.076,6.787a.881.881,0,0,0,.881.652.96.96,0,0,0,.229,0,.881.881,0,0,0,.625-1.074l-.52-1.946a.894.894,0,1,0-1.735.431Z",
    transform: "translate(-1.736 -0.447)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M11.968,8.321a.881.881,0,1,0,1.523-.881l-1-1.761a.877.877,0,1,0-1.506.9Z",
    transform: "translate(-1.296 -0.625)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M9.379,10.621a.881.881,0,1,0,1.242-1.25L9.2,7.979A.881.881,0,0,0,7.979,9.2Z",
    transform: "translate(-0.935 -0.935)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M5.7,12.489l1.761,1a.88.88,0,1,0,.881-1.523l-1.761-.986A.872.872,0,1,0,5.7,12.489Z",
    transform: "translate(-0.629 -1.298)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M4.392,16.255l1.946.52a.96.96,0,0,0,.22,0,.888.888,0,0,0,.229-1.761L4.85,14.556a.88.88,0,0,0-.458,1.7Z",
    transform: "translate(-0.447 -1.736)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M6.107,20.231a.881.881,0,0,0,0-1.761H4.091a.881.881,0,0,0,0,1.761Z",
    transform: "translate(-0.384 -2.207)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M7.411,22.481a.881.881,0,0,0-1.074-.625l-1.946.52a.882.882,0,0,0,.255,1.735.96.96,0,0,0,.229,0l1.946-.528a.881.881,0,0,0,.59-1.1Z",
    transform: "translate(-0.446 -2.608)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M8.647,25.4a.881.881,0,0,0-1.206-.326l-1.761,1A.884.884,0,0,0,6.56,27.61L8.321,26.6a.881.881,0,0,0,.326-1.2Z",
    transform: "translate(-0.626 -2.982)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M10.606,27.9a.881.881,0,0,0-1.25,0L7.965,29.322A.885.885,0,0,0,9.189,30.6l1.418-1.453A.881.881,0,0,0,10.606,27.9Z",
    transform: "translate(-0.92 -3.303)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M13.174,29.824a.881.881,0,0,0-1.206.317l-1,1.761a.88.88,0,1,0,1.523.881l1-1.761A.881.881,0,0,0,13.174,29.824Z",
    transform: "translate(-1.295 -3.549)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M16.15,31a.881.881,0,0,0-1.074.625l-.52,2.016a.881.881,0,0,0,.616,1.074.722.722,0,0,0,.229,0,.881.881,0,0,0,.881-.652l.52-1.946A.881.881,0,0,0,16.15,31Z",
    transform: "translate(-1.736 -3.7)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M19.351,31.44a.881.881,0,0,0-.881.881v2.016a.881.881,0,0,0,1.761,0V32.321A.881.881,0,0,0,19.351,31.44Z",
    transform: "translate(-2.207 -3.756)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M23.555,31.648a.877.877,0,1,0-1.7.431l.52,1.946a.881.881,0,0,0,.881.652.722.722,0,0,0,.229,0,.881.881,0,0,0,.6-1.039Z",
    transform: "translate(-2.608 -3.7)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M26.6,30.145a.881.881,0,0,0-1.523.881l1,1.761a.884.884,0,0,0,1.532-.881Z",
    transform: "translate(-2.984 -3.553)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M29.153,27.911a.881.881,0,0,0-1.242,1.242l1.418,1.453a.894.894,0,1,0,1.277-1.25Z",
    transform: "translate(-3.309 -3.309)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M32.766,26.08l-1.761-1a.881.881,0,0,0-.881,1.523l1.761,1.013a.884.884,0,0,0,.881-1.532Z",
    transform: "translate(-3.55 -2.984)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M34.055,22.375l-1.946-.52a.88.88,0,1,0-.458,1.7l1.946.528a1.012,1.012,0,0,0,.229,0,.865.865,0,0,0,.229-1.708Z",
    transform: "translate(-3.703 -2.608)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M34.337,18.47H32.321a.881.881,0,1,0,0,1.761h2.016a.881.881,0,0,0,0-1.761Z",
    transform: "translate(-3.756 -2.207)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M31,16.15a.881.881,0,0,0,.881.66,1.118,1.118,0,0,0,.229,0l1.946-.52a.892.892,0,0,0-.414-1.735l-1.946.52A.881.881,0,0,0,31,16.15Z",
    transform: "translate(-3.7 -1.736)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M29.824,13.171a.881.881,0,0,0,1.2.317l1.761-1a.881.881,0,1,0-.881-1.523l-1.761,1a.881.881,0,0,0-.317,1.206Z",
    transform: "translate(-3.549 -1.293)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M27.905,10.606a.882.882,0,0,0,1.242,0L30.6,9.189a.875.875,0,0,0-1.25-1.224l-1.444,1.4A.881.881,0,0,0,27.905,10.606Z",
    transform: "translate(-3.303 -0.92)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M25.4,8.647a.881.881,0,0,0,1.2-.326L27.61,6.56a.884.884,0,0,0-1.532-.881l-1,1.761A.881.881,0,0,0,25.4,8.647Z",
    transform: "translate(-2.982 -0.626)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M22.482,7.412a1.013,1.013,0,0,0,.229,0,.881.881,0,0,0,.881-.652l.493-1.911A.883.883,0,1,0,22.376,4.4l-.52,1.946A.881.881,0,0,0,22.482,7.412Z",
    transform: "translate(-2.608 -0.447)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M19.971,24.52a.881.881,0,1,0,0,1.761h2.413a.881.881,0,0,0,0-1.761Z",
    transform: "translate(-2.281 -2.93)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M24.964,26.663a.185.185,0,0,0,.1.194.167.167,0,0,0,.088,0,.246.246,0,0,0,.114,0,.194.194,0,0,0,.141.158h.044a.211.211,0,0,0,.15-.079.185.185,0,0,0,.176.123.194.194,0,0,0,.176-.123.176.176,0,0,0,.141.079h.053a.2.2,0,0,0,.132-.158.247.247,0,0,0,.114,0,.2.2,0,0,0,.1,0,.176.176,0,0,0,.088-.194h.07a.194.194,0,0,0,.132-.053.176.176,0,0,0,0-.211h0a.185.185,0,0,0,.167-.1.176.176,0,0,0,0-.211.167.167,0,0,0,.158-.132.194.194,0,0,0-.062-.194.194.194,0,0,0,0-.352.194.194,0,0,0,.062-.194.2.2,0,0,0-.15-.141.193.193,0,0,0-.2-.291.176.176,0,0,0,0-.211.185.185,0,0,0-.2,0,.176.176,0,0,0-.088-.194.185.185,0,0,0-.211,0,.185.185,0,0,0-.335-.088.186.186,0,0,0-.343,0,.185.185,0,0,0-.194-.07.194.194,0,0,0-.141.158.176.176,0,0,0-.2,0,.185.185,0,0,0-.1.194.185.185,0,0,0-.2,0,.2.2,0,0,0,0,.211.185.185,0,0,0-.2.088.2.2,0,0,0,0,.2.2.2,0,0,0-.15.141.194.194,0,0,0,.062.194.194.194,0,0,0,0,.352.194.194,0,0,0-.062.194.176.176,0,0,0,.158.132.2.2,0,0,0,.167.308h0a.176.176,0,0,0,0,.211.194.194,0,0,0,.132.053A.167.167,0,0,0,24.964,26.663Z",
    transform: "translate(-2.907 -2.889)",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-8",
    "data-name": "Layer 2",
    transform: "translate(156.285 192.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-8",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M19.561,9l-7.106,7.5a10.918,10.918,0,0,0,0,14.846,9.686,9.686,0,0,0,14.22,0,10.927,10.927,0,0,0,0-14.854ZM25.4,30.133a7.925,7.925,0,0,1-11.667,0,9.149,9.149,0,0,1,0-12.433l5.829-6.164L25.4,17.7h0a9.149,9.149,0,0,1,0,12.477Z",
    transform: "translate(-1.142 -1.075)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M27.856,9.686A3.7,3.7,0,0,0,30.5,8.515a4.147,4.147,0,0,0,0-5.644L27.856,0,25.17,2.826a4.165,4.165,0,0,0,0,5.644,3.7,3.7,0,0,0,2.686,1.215Z",
    transform: "translate(-2.877)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M9.4,6.941,5.486,2.82l-3.9,4.121a5.961,5.961,0,0,0,0,8.092,5.336,5.336,0,0,0,7.81,0A5.961,5.961,0,0,0,9.4,6.941ZM8.11,13.818a3.522,3.522,0,0,1-5.283,0,4.174,4.174,0,0,1,0-5.671L5.468,5.382,8.11,8.147h0a4.147,4.147,0,0,1,0,5.671Z",
    transform: "translate(-0.002 -0.337)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M23.488,24.091H21.269v-2.21a.881.881,0,1,0-1.761,0v2.228H17.281a.881.881,0,1,0,0,1.761h2.228v2.175a.881.881,0,1,0,1.761,0V25.852h2.219a.881.881,0,1,0,0-1.761Z",
    transform: "translate(-1.961 -2.509)",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-9",
    "data-name": "Layer 2",
    transform: "translate(5.006 28.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-9",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M14.581,32.668l-3.3-2.122a.881.881,0,0,0-.951,0L7.493,32.36,4.667,30.546a.881.881,0,0,0-1,0L1.761,32V2.721L3.707,3.981a.881.881,0,0,0,.96,0L7.493,2.158l2.835,1.823a.881.881,0,0,0,.986,0l2.774-2.016,2.818,1.99a.881.881,0,0,0,.986,0l1.946-1.259V19.372a.881.881,0,1,0,1.761,0V1.11A.881.881,0,0,0,20.252.37L17.443,2.175,14.617.168a.881.881,0,0,0-1.021,0L10.778,2.175,7.969.37a.881.881,0,0,0-.925,0L4.191,2.193,1.356.37A.881.881,0,0,0,0,1.11V33.751a.881.881,0,0,0,.484.792.881.881,0,0,0,.4.088.881.881,0,0,0,.528-.176l2.818-2.1,2.791,1.761a.881.881,0,0,0,.951,0L10.8,32.3l2.826,1.814a.881.881,0,0,0,.951-1.479Z",
    transform: "translate(0 -0.005)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M25.246,26.547,23.124,24.31,21,26.547a3.293,3.293,0,0,0,0,4.464,2.9,2.9,0,0,0,4.244,0,3.276,3.276,0,0,0,0-4.464Z",
    transform: "translate(-2.405 -2.909)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M4.131,7.761H13.35A.881.881,0,0,0,13.35,6H4.131a.881.881,0,1,0,0,1.761Z",
    transform: "translate(-0.388 -0.721)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M17.286,19.21H4.131a.881.881,0,0,0,0,1.761H17.286a.881.881,0,0,0,0-1.761Z",
    transform: "translate(-0.388 -2.299)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M20.782,6H18.141a.881.881,0,0,0,0,1.761h2.642a.881.881,0,1,0,0-1.761Z",
    transform: "translate(-2.062 -0.721)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M4.131,14.42a.881.881,0,1,0,0,1.761H6.772a.881.881,0,1,0,0-1.761Z",
    transform: "translate(-0.388 -1.727)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M9.181,14.42a.881.881,0,1,0,0,1.761h2.642a.881.881,0,1,0,0-1.761Z",
    transform: "translate(-0.992 -1.727)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M6.732,27.291a.881.881,0,1,0,0-1.761H4.091a.881.881,0,1,0,0,1.761Z",
    transform: "translate(-0.383 -3.054)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M16.6,26.8H14.838a.881.881,0,0,0-.7.37l.431-1.092a.918.918,0,1,0-1.761-.52l-1.338,4.3a.881.881,0,0,0,.581,1.1.819.819,0,0,0,.255,0,.881.881,0,0,0,.881-.625l.828-2.642a.881.881,0,0,0,.238.564.872.872,0,0,0,.625,1.488h1.761a.872.872,0,0,0,.625-1.488A.858.858,0,0,0,16.6,26.8Z",
    transform: "translate(-1.366 -2.979)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M14.241,16.181h6a.881.881,0,1,0,0-1.761h-6a.881.881,0,1,0,0,1.761Z",
    transform: "translate(-1.596 -1.727)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M14.23,10.751a.881.881,0,0,0-.881-.881H4.131a.881.881,0,0,0,0,1.761H13.35A.881.881,0,0,0,14.23,10.751Z",
    transform: "translate(-0.388 -1.183)",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(100.51 109.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-10",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-10",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77-2",
    "data-name": "Path 77",
    d: "M33.264,1.982V1.154a.881.881,0,0,0-1.761,0V1.92H29.944V1.154a.881.881,0,0,0-1.761,0V1.92H23.832L23.119.96a.881.881,0,0,0-.7-.352H20.653a.881.881,0,0,0-.7.352l-.713.96H12.717a.859.859,0,0,0-.9-.837l-5.6.15L5.725.423A.881.881,0,0,0,4.967,0H3.62a.881.881,0,0,0-.608.247L1.638,1.568a.881.881,0,0,0-.273.634v.343a.881.881,0,0,0-.881-.079.881.881,0,0,0-.484.8V5.39a.881.881,0,0,0,.308.669l.934.8.123.07v5.725a4.007,4.007,0,0,0,4,4,.881.881,0,0,0,.608-.247,2.862,2.862,0,0,0,2.642,1.761,2.2,2.2,0,0,0,.819-.132,1.559,1.559,0,0,0,.15-.106,2.836,2.836,0,0,0,1.127.238A2.88,2.88,0,0,0,13.581,15.3a2.554,2.554,0,0,0-.1-.7H24.933a3.083,3.083,0,0,0-.1.7,2.871,2.871,0,0,0,3.857,2.695.819.819,0,0,0,.335-.176,2.783,2.783,0,0,0,1.339.352,2.827,2.827,0,0,0,2.748-3.655,5.179,5.179,0,0,0,4.219-5.082V6.6a4.668,4.668,0,0,0-4.069-4.615ZM31.5,8.208H29.944V7.821h1.585ZM29.918,9.97H31.5v.379H29.944ZM31.5,6.059H29.944V5.681h1.585Zm-1.559,6.05h1.585v.59a2.792,2.792,0,0,0-1.154-.247,3.426,3.426,0,0,0-.432,0Zm1.585-8.428v.238H29.944V3.681Zm-3.347,8.807a2.642,2.642,0,0,0-.467,0,2.836,2.836,0,0,0-1.524.449,1.251,1.251,0,0,0-.176,0H12.691a.722.722,0,0,0-.238.053.881.881,0,0,0,.273-.634V3.681H28.183ZM3.972,1.761h.5l.5.828a.881.881,0,0,0,.775.423L9.635,2.9v3.03L3.6,6.412a.881.881,0,0,0-.476.211V2.572ZM5.786,15.016a.881.881,0,0,0-.423-.123,2.237,2.237,0,0,1-2.237-2.237V7.97a.881.881,0,0,0,.546.2h.07l6.825-.555a.81.81,0,0,0,.379-.132V12.33a.7.7,0,0,0,.044.194H10.7a2.7,2.7,0,0,0-1.136.238,1.347,1.347,0,0,0-.141-.1,2.246,2.246,0,0,0-.819-.141,2.871,2.871,0,0,0-2.818,2.492Zm1.761.308a1.092,1.092,0,0,1,.493-.881,2.7,2.7,0,0,0-.159.881,2.748,2.748,0,0,0,.159.881,1.083,1.083,0,0,1-.528-.881Zm3.206,1.11a1.11,1.11,0,1,1,1.11-1.11A1.11,1.11,0,0,1,10.753,16.434Zm15.853-1.11a1.1,1.1,0,0,1,1.11-1.11h0a2.906,2.906,0,0,0,0,2.219h0a1.11,1.11,0,0,1-1.136-1.11Zm3.769,1.11a1.143,1.143,0,1,0-.026,0Zm5.2-6.975a3.4,3.4,0,0,1-2.29,3.206V3.752A2.906,2.906,0,0,1,35.581,6.6Z",
    transform: "translate(0 0)",
    fill: "#4156a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Recycle_1929764",
    transform: "translate(17.405 5.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M36.615,26.567l-1.356-1.778a.215.215,0,0,0-.348,0l-1.356,1.778a.221.221,0,0,0,.178.356h.548a2.272,2.272,0,0,1-2.252,2.037h-.015a.218.218,0,0,0-.081.422,2.837,2.837,0,0,0,1.1.215,2.9,2.9,0,0,0,2.889-2.674h.526A.22.22,0,0,0,36.615,26.567Z",
    transform: "translate(-29.621 -23.552)",
    fill: "#4156a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M5.417,11.874H4.869A2.259,2.259,0,0,1,7.114,9.837h.015a.218.218,0,0,0,.081-.422,2.836,2.836,0,0,0-1.1-.215,2.9,2.9,0,0,0-2.889,2.674H2.706a.221.221,0,0,0-.178.356l1.356,1.778a.215.215,0,0,0,.348,0L5.588,12.23A.217.217,0,0,0,5.417,11.874Z",
    transform: "translate(-2.482 -9.2)",
    fill: "#4156a6"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccs);
export default __webpack_public_path__ + "static/media/accs.5f96c6fe35a3db44cfc7e7f26cbb3329.svg";
export { ForwardRef as ReactComponent };